/* unplugin-vue-components disabled */import { render } from "./MenuDetails.vue?vue&type=template&id=3632f476&scoped=true"
import script from "./MenuDetails.vue?vue&type=script&lang=js"
export * from "./MenuDetails.vue?vue&type=script&lang=js"

import "./MenuDetails.vue?vue&type=style&index=0&id=3632f476&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3632f476"]])

export default __exports__